class CartDiscount extends HTMLElement {
    constructor() {
        super();
        this.fetchRequestOpts = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        };

        this.isProcessing = false; // Flag to prevent multiple fetches
        this.init();
    }

    init() {
        this.cartDrawer = document.getElementById('cart-drawer');        

        // const cart_form = this.querySelector('.discount_submit')?.closest('form') || this.querySelector('.discount_submit')?.closest('cart-drawer').querySelector('form');
        
        // if (cart_form) {
            // cart_form.addEventListener('submit', this.applyDiscount.bind(this));
            this.submitBtn = this.querySelector('.discount_submit');
            this.submitBtn?.addEventListener('click', this.applyDiscount.bind(this));

            this.discountInput = document.querySelector('input[name="discount"]');
            this.discountInput?.addEventListener('keydown', this.preventEnterKey.bind(this));
        // }

        const removeDiscountButton = this.querySelector('.cart-discount__pill-remove');
        if (removeDiscountButton) {
            removeDiscountButton.addEventListener('click', this.removeDiscount.bind(this));
        }
    }

    preventEnterKey(event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    }

    getElementHTML(html, selector) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = html;

        const el = tmpl.content.querySelector(selector);
        return el ? el.innerHTML : '';
    }

    async applyDiscount(event) {
        event.preventDefault();

        if (this.isProcessing) return; // Prevent multiple fetch calls
        this.isProcessing = true; // Set processing flag to true

        const cartDiscountError = this.querySelector('.cart-discount__error');
        const cartDiscountErrorDiscountCode = this.querySelector('.cartDiscountErrorDiscountCode');
        const cartDiscountErrorShipping = this.querySelector('.cartDiscountErrorShipping');

        const discountCode = document.querySelector('input[name="discount"]');
        if (!discountCode) return;

        const discountCodeValue = discountCode.value;
        if (discountCodeValue == '') return;

        const existingDiscounts = this.existingDiscountsArray();

        if (existingDiscounts.includes(discountCodeValue)) return;

        // Hide error messages
        if (cartDiscountError) cartDiscountError.classList.add('hidden');
        if (cartDiscountErrorDiscountCode) cartDiscountErrorDiscountCode.classList.add('hidden');
        if (cartDiscountErrorShipping) cartDiscountErrorShipping.classList.add('hidden');

        this.submitBtn.classList.add('is-loading');

        try {
            const sections = this.getSectionsToRender().map((section) => section.section);
            this.fetchRequestOpts.body = JSON.stringify({
                discount: [...existingDiscounts, discountCodeValue].join(','),
                sections: [...new Set(sections)],
                sections_url: window.location.pathname,
            });

            const response = await fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
            const data = await response.json();

            // Check if the discount code is applicable
            if (data.discount_codes.find(discount => discount.code === discountCodeValue && !discount.applicable)) {
                discountCode.value = '';
                this.handleDiscountError('discount_code', theme.strings.discount.discount_code_error);
                this.submitBtn.classList.remove('is-loading');
                return;
            }

            const sectionId = document.querySelector('cart-items')?.dataset.section;
            const newHtml = data.sections[sectionId];
            const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
            const section = parsedHtml.getElementById(`shopify-section-${sectionId}`);
            const discountCodes = section?.querySelectorAll('.cart-discount__pill') || [];
            const codes = Array.from(discountCodes)
                .map((element) => element.dataset.discountCode)
                .filter(Boolean);

            if (
                codes.length === existingDiscounts.length &&
                codes.every(( /** @type {string} */ code) => existingDiscounts.includes(code)) &&
                data.discount_codes.find(( /** @type {{ code: string; applicable: boolean; }} */ discount) => {
                    return discount.code === discountCodeValue && discount.applicable === true;
                })
            ) {
                const isShippingDiscount = data.discount_codes.some((discount) => discount.code === discountCodeValue && discount.type === 'shipping');
                if (isShippingDiscount) {
                    this.handleDiscountError('shipping', theme.strings.discount.shipping_discount_error);
                    discountCode.value = '';
                    return;
                }
            }

            this.submitBtn.classList.add('is-loading');
            this.submitBtn.classList.add('is-success');

            const cartItems = document.querySelector('cart-items');
            // cartItems.freeGift();
            if (cartItems) cartItems.refresh();

            this.submitBtn.classList.remove('is-loading');
            this.submitBtn.classList.remove('is-success');
        } catch (error) {
            console.error('Error applying discount:', error);
            this.handleDiscountError('discount_code', theme.strings.discount__error);
            this.submitBtn.classList.remove('is-loading');
        } finally {
            this.isProcessing = false; // Reset processing flag after the request is done
        }
    }

    async removeDiscount(event) {
        event.preventDefault();
        event.stopPropagation();

        if ((event instanceof KeyboardEvent && event.key !== 'Enter') || !(event instanceof MouseEvent)) return;

        const pill = event.target.closest('.cart-discount__pill');
        if (!pill) return;

        const discountCode = pill.dataset.discountCode;
        if (!discountCode) return;

        const existingDiscounts = this.existingDiscountsArray();
        const index = existingDiscounts.indexOf(discountCode);
        if (index === -1) return;

        existingDiscounts.splice(index, 1);

        try {
            const sections = this.getSectionsToRender().map((section) => section.section);
            this.fetchRequestOpts.body = JSON.stringify({
                discount: existingDiscounts.join(','),
                sections: [...new Set(sections)],
                sections_url: window.location.pathname,
            });
            const response = await fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
            const data = await response.json();

            const cartItems = document.querySelector('cart-items');
            cartItems.freeGift();
            if (cartItems) cartItems.refreshNewData();
        } catch (error) {
            console.error('Error removing discount:', error);
        }
    }

    handleDiscountError(type, message) {
        const cartDiscountError = this.querySelector('.cart-discount__error');
        const cartDiscountErrorDiscountCode = this.querySelector('.cartDiscountErrorDiscountCode');

        if (cartDiscountError) cartDiscountError.classList.remove('hidden');
        if (cartDiscountErrorDiscountCode) {
            cartDiscountErrorDiscountCode.textContent = message || 'An error occurred.';
            cartDiscountErrorDiscountCode.classList.remove('hidden');
        }
    }

    existingDiscountsArray() {
        const discountCodes = [];
        const discountPills = document.querySelectorAll('.cart-discount__pill');
        for (const pill of discountPills) {
            if (pill instanceof HTMLLIElement && pill.dataset.discountCode) {
                discountCodes.push(pill.dataset.discountCode);
            }
        }
        return discountCodes;
    }

    getSectionsToRender() {
        let sections = [];

        if (this.cartDrawer) {
            const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
            sections = [
                ...sections,
                {
                    id: 'cart-items',
                    section: cartDrawerId,
                    selector: 'cart-items',
                },
                {
                    id: 'cart-drawer',
                    section: cartDrawerId,
                    selector: '.cart-drawer__summary',
                }
            ];
        } else {
            sections = [
                ...sections,
                {
                    id: 'cart-items',
                    section: document.getElementById('cart-items')?.dataset.section,
                    selector: 'cart-items',
                },
                {
                    id: 'cart-summary',
                    section: document.getElementById('cart-summary')?.dataset.section,
                    selector: '.cart__summary',
                },
            ];
        }

        return sections;
    }
}

customElements.define('cart-discount', CartDiscount);